import { render } from "./IndividualSportsResults.vue?vue&type=template&id=fbd931e6&scoped=true"
import script from "./IndividualSportsResults.vue?vue&type=script&lang=js"
export * from "./IndividualSportsResults.vue?vue&type=script&lang=js"

import "./IndividualSportsResults.vue?vue&type=style&index=0&id=fbd931e6&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/broome-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbd931e6"]])

export default __exports__